import Vue from 'vue'

export default {
  getApplicationSetting () {
    return Vue.prototype.$http.get('/application_settings')
  }
}
